module.exports = __webpack_public_path__ + "img/international-students.7e267b2a.png";